import { render, staticRenderFns } from "./TableSetting.vue?vue&type=template&id=22fd7caa&"
import script from "./TableSetting.vue?vue&type=script&lang=ts&"
export * from "./TableSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports